<div class="modal-body">
  <div class="row">
    <h2 class="modal-title">{{ 'brapi-sync.variable.heading' | translate }}</h2>
  </div>
  <div class="row">
    <div class="col-10">
      <app-study-selector (onSelect)="onStudySelect()" [trialDisabled]="!isStudySelectable"
        [locationDisabled]="!isStudySelectable"
      [studyDisabled]="!isStudySelectable"></app-study-selector>
    </div>
  </div>
  @if (isLoading) {
    <div class="row">
      <div class="col">
        <span class="throbber"></span>
      </div>
    </div>
  }
  <div class="row">
    @if (context.sourceStudy?.studyDbId && !isLoading) {
      <div class="col">
        <app-collapsible [heading]="'brapi-sync.variable.connection-info' | translate">
          <div class="card">
            <div class="card-body">
              <h5><span
              class="badge badge-pill text-bg-success text-white">{{ context.sourceStudy.studyName }}</span>
            </h5>
          </div>
        </div>
      </app-collapsible>
      <app-collapsible [heading]="'brapi-sync.variable.variables' | translate">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-curved">
            <caption></caption>
            <thead class="thead-light">
              <tr>
                <th scope="col">{{ 'brapi-sync.variable.table.source-observation-variable-name' | translate }}</th>
                <th scope="col">{{ 'brapi-sync.variable.table.source-variable-synonyms' | translate }}</th>
                <th scope="col">{{ 'brapi-sync.variable.table.source-variable-metadata' | translate }}</th>
                <th scope="col">{{ 'brapi-sync.variable.table.target-observation-variable-name' | translate }}</th>
                <th scope="col">{{ 'brapi-sync.variable.table.target-synonyms' | translate }}</th>
                <th scope="col">{{ 'brapi-sync.variable.table.status' | translate }}</th>
              </tr>
            </thead>
            <tbody>
            @if (Object.keys(sourceVariables).length !== 0) {
                @for (key of sourceVariables | objectKeys; track key) {
                    <tr>
                        <td>{{ sourceVariables[key].observationVariableName }}</td>
                        <td>{{ sourceVariables[key].synonyms }}</td>
                        <td>
                            <app-expandable-json-viewer
                                    [json]="sanitizeObject(sourceVariables[key])"></app-expandable-json-viewer>
                        </td>
                        <td>{{ variablesMap[key]?.observationVariableName }}</td>
                        <td>{{ variablesMap[key]?.synonyms }}</td>
                        <td>
                            @if (isValidMapping(sourceVariables[key])) {
                                <span><i
                                        class="fa fa-check text-success"></i></span>
                            }
                            @if (!isValidMapping(sourceVariables[key])) {
                                <span><i
                                        class="fa fa-times text-danger"></i> {{ 'brapi-sync.variable.status.no-variable-found' | translate }}</span>
                            }
                        </td>
                    </tr>
                }
            } @else {
                <tr><td colspan="6">{{'no.data' | translate}}</td></tr>
            }
            </tbody>
          </table>
        </div>
      </app-collapsible>
    </div>
  }
</div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancel()">{{ 'cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary ms-2" (click)="post()" [disabled]="!isValid()">
    @if (isSaving) {
      <span class="throbber throbber-btn"></span>
    }
    {{ 'brapi-sync.buttons.import-variables' | translate }}
  </button>
  <button type="button" class="btn btn-info ms-2" (click)="next()" [disabled]="!canProceed()">
    {{ 'next' | translate }}
  </button>
</div>



